import http from '../jslibs/axios/http'

// 行业解决方案列表
export const getIndustrySolutions = data => http.get('/v1/cms/IndustrySolutions', data)

// 新增行业解决方案
export const addIndustrySolutions = data => http.post('/v1/cms/IndustrySolutions', data)

// 删除行业解决方案
export const deleteIndustrySolutions = id => http.delete(`/v1/cms/IndustrySolutions/${id}`)

// 编辑标行业解决方案
export const editIndustrySolutions = (id, data) => http.put(`/v1/cms/IndustrySolutions/${id}`, data)

// 行业解决方案详情
export const industrySolutionsDetail = id => http.get(`/v1/cms/IndustrySolutions/${id}`)

// 隐藏/显示行业解决方案
export const showIndustrySolutionsOption = id => http.get(`/v1/cms/IndustrySolutionsOption/${id}`)
